import { useCallback, useEffect, useState } from "react";

function useApiData({ apiCall, dependency = [], pagination }) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    setError(null); // Clear any previous errors
    try {
      const response = apiCall && (await apiCall());
      if (pagination && pagination?.isServerSidePagination) {
        const { totalRecordsCount, pageSize, pageNumber, pagesCount } =
          response?.data;
        pagination?.setApiData(
          totalRecordsCount,
          pageSize,
          pageNumber,
          pagesCount,
        );
        setData(response?.data?.records || []);
      } else {
        setData(response.data);
      }
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  }, [apiCall]);

  useEffect(() => {
    if (apiCall) {
      fetchData();
    } else setIsLoading(false);
  }, [...dependency]);

  return { isLoading, data, error, refetch: fetchData };
}

export default useApiData;
